import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BomItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemDrawingThumbnailSelector =
  (bomItemPointer: BomItemPointer, attachmentId?: string) =>
  (state: RootAppState) => {
    if (!bomItemPointer || !bomItemPointer.id) return null

    const bomItem = bomItemSelector(state, bomItemPointer)

    if (!bomItem) {
      return null
    }

    switch (bomItem.type) {
      case BomItemType.partType:
      case BomItemType.assemblyInstance:
      case BomItemType.assemblyType:
        return bomItem.engineeringDrawingThumbnail
      default:
        return null
    }
  }
